import { useEffect } from 'react';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormGroup } from '../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { convertToNumber } from '../../../../_helpers/_methods';

function SingleFormInput({
  register,
  min,
  max,
  errors,
  title,
  id,
  isEdit,
  inputType,
  type,
  setValue,
  errMsg,
  setErrMsg,
  defaultValue = null
}) {
  const [error, setError] = useState(errMsg);
  const handleErrorMessage = (msg) => {
    if (setErrMsg) {
      setErrMsg(msg);
    }
    setError(msg);
  };

  useEffect(() => {
    setError(errMsg);
  }, [errMsg]);
  const intl = useIntl();
  useEffect(() => {
    if (isEdit) {
      const getOfficeKind = async () => {
        const response = await fetchWrapper.get(`/${type}/${id}/`);
        setValue('title', response.data.title);
      };
      getOfficeKind();
    }
  }, [id]);
  return (
    <div className="my-2">
      <div className="row">
        <div className="">
          {/* {isEdit ? <FormattedMessage id="edit" /> : null} */}
          <FormattedMessage id={`${title}.placeholder`}>
            {(placeholder) => (
              <FormGroup
                type={inputType}
                id="title"
                label={<FormattedMessage id={title} />}
                max={max}
                min={min}
                error={errors}
                errorId={type === 'fiscal-year' ? 'fiscal_year' : title}
                placeholder={placeholder[0]}
                required={true}
                defaultValue={defaultValue && defaultValue}
                onChange={
                  type === 'fiscal-year'
                    ? (e) => {
                        let value = '';
                        if (!isNaN(e.target.value)) {
                          let inputYearLength = e.target.value;
                          let inputYear = +e.target.value;
                          if (inputYear >= 2000 && inputYear < 2090) {
                            handleErrorMessage(false);
                          } else {
                            if (inputYearLength === 4) {
                              console.log('ehat');
                              handleErrorMessage(
                                intl.formatMessage({ id: 'error.fiscal_year_range_type' })
                              );
                            }
                            if (inputYearLength < 4) {
                              handleErrorMessage(false);
                            }
                          }

                          return;
                        } else {
                          handleErrorMessage(
                            intl.formatMessage({ id: 'error.fiscal_year_text_type' })
                          );
                          value = convertToNumber(e.target.value);

                          e.target.value = value;
                        }
                      }
                    : null
                }
                register={register}
              />
            )}
          </FormattedMessage>
          {error ? <smalll className="text-danger ms-1">{error}</smalll> : error}
        </div>
      </div>
    </div>
  );
}

export default SingleFormInput;
